import { Radio } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './laptop.less';
import './style.less';
import { useMediaQuery } from 'react-responsive';
import Loader from '../Loader/Loader';

const PreviewForm = ({ form }) => {
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState(localStorage.getItem('wf-preview-mode') || 'mobile');
  const { t } = useTranslation(['builder']);

  const isMobile = useMediaQuery({ maxWidth: 993 });
  const changeMode = (e) => {
    setMode(e.target.value);
    localStorage.setItem('wf-preview-mode', e.target.value);
  };

  const messageHandler = useCallback((e) => {
    if (e && e.data && e.data.type === 'wf-loaded') {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('message', messageHandler);
    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, [messageHandler]);

  return (
    <section className="preview-section">
      {' '}
      {!isMobile && (
        <Radio.Group
          className="preview-controls"
          buttonStyle="solid"
          onChange={changeMode}
          value={mode}
          style={{
            boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
            borderRadius: 6,
          }}
        >
          <Radio.Button value="mobile">{t('previewMode.screen.mobile', 'Mobile')}</Radio.Button>
          <Radio.Button value="desktop">{t('previewMode.screen.desktop', 'Desktop')}</Radio.Button>
          <Radio.Button value="widget">Widget</Radio.Button>
        </Radio.Group>
      )}
      <div className="preview-content">
        {isMobile && (
          <div
            style={{
              width: '100%',
              maxWidth: '400px',
              margin: 'auto',
              height: '100%',
            }}
          >
            {' '}
            {loading && <Loader />} <IframeContainer form={form} />
          </div>
        )}
        {!isMobile && (
          <>
            <div
              style={{
                width: '100%',
                maxWidth: '400px',
                margin: 'auto',
                height: '100%',
                display: mode === 'mobile' ? 'block' : 'none',
              }}
            >
              <div className="marvel-device iphone-x">
                <div className="notch">
                  <div className="camera"></div>
                  <div className="speaker"></div>
                </div>
                <div className="top-bar"></div>
                <div className="sleep"></div>
                <div className="bottom-bar"></div>
                <div className="volume"></div>
                <div className="overflow">
                  <div className="shadow shadow--tr"></div>
                  <div className="shadow shadow--tl"></div>
                  <div className="shadow shadow--br"></div>
                  <div className="shadow shadow--bl"></div>
                </div>
                <div className="inner-shadow"></div>
                <div className="screen">
                  {loading && <Loader />}
                  <IframeContainer
                    form={form}
                    mode={mode}
                    loading={loading}
                    style={{ backgroundColor: '#fff' }}
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                width: '1000px',
                margin: 'auto',
                display: mode === 'desktop' ? 'block' : 'none',
              }}
            >
              <div className="object-laptop">
                <div className="screen">
                  <div className="lcd">
                    {loading && <Loader />}{' '}
                    <IframeContainer form={form} style={{ padding: '20px' }} loading={loading} />
                  </div>
                  <div className="highlight one"></div>
                  <div className="highlight two"></div>
                </div>
                <div className="keyboard one"></div>
                <div className="keyboard two"></div>
              </div>
            </div>
            <div
              style={{
                width: '1000px',
                margin: 'auto',
                display: mode === 'widget' ? 'block' : 'none',
              }}
            >
              <div className="object-laptop">
                <div className="screen">
                  <div className="lcd">
                    {' '}
                    <IframeContainer form={form} mode="widget" />
                  </div>
                  <div className="highlight one"></div>
                  <div className="highlight two"></div>
                </div>
                <div className="keyboard one"></div>
                <div className="keyboard two"></div>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

const IframeContainer = ({ form, loading, mode, style }) => {
  const BASE_URL =
    window.location.host === 'app.whatsform.com'
      ? 'https://whatsform.com/' + form.link
      : 'https://staging.whatsform.com/' + form.link;

  const iframeRef = useRef(null);
  useEffect(() => {
    if (mode && !loading && iframeRef.current) {
      iframeRef.current.contentWindow.postMessage({ type: 'wf-preview-type', mode }, '*');
    }
  }, [mode, loading]);
  return (
    <iframe
      ref={iframeRef}
      title="Form Preview"
      frameBorder="0"
      id={`formPreview-${mode}`}
      name="whatsform-preview"
      src={mode === 'widget' ? `${BASE_URL}/preview-widget` : `${BASE_URL}/preview`}
      width="100%"
      height="100%"
      style={{
        background: '#f4f5f6',
        ...style,
      }}
    ></iframe>
  );
};

export default PreviewForm;
